import React, { useState, useEffect, forwardRef } from "react";
import FormItem from "antd/es/form/FormItem";
import { Col, Row, Spin, message } from 'antd';
import { useSpring, animated } from 'react-spring'

export default forwardRef((props: any, ref: any) => {
  const { form, inputData, language } = props,
    { required, questions, defaultValue, id, mediaFiles } = inputData,
    { getFieldDecorator } = form;
  const [loading, setLoading] = useState(true);
  const [src, setSrc] = useState('');
  const options = useSpring({ delay: 500, to: { opacity: 1 }, from: { opacity: 0 } });

  useEffect(() => {
    let isMounted = true;

    const image = new Image();
    image.src = mediaFiles[0].src;
    image.decode()
    .then(() => {
      setLoading(false);
      setSrc(image.src);
    })
    .catch((error) => {
      message.error(error.message);
      console.error(error, error.toString())
    });

    return () => { isMounted = false }
  }, [mediaFiles]);

  return (
    <FormItem>
      {getFieldDecorator(id, {
        initialValue: defaultValue,
        rules: [
          {
            required,
            message: "Required Field"
          }
        ]
      })(
        <Row type="flex" justify="center" align="middle">
          {
            loading && <Spin delay={500} size="large" />
          }
          {
            !loading && (
              <Col>
                <animated.div style={options}>
                  <img
                    style={{ maxHeight: '50vmin', maxWidth: '50vmin' }}
                    src={src}
                    alt="picture goes here"
                  />
                </animated.div>
              </Col>   
            )
          }
        </Row>
      )}
    </FormItem>
  );
});
